<template>
  <div class="page">
    <b-container fluid>
      <b-row>
        <b-col cols="8" class="mx-auto">
          <b-img src="static/DubaiDIY/宠物/公司展会DIY卡-12.png" fluid />
        </b-col>
      </b-row>
      <div>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">Phone number</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="mobile"
              id="input-mobile"
              type="tel"
              placeholder="input your phone number"
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />
        <!-- <b-button @click="getCallStatus">测试接口</b-button> -->
        <b-row class="rowBtn">
          <b-col cols="10" class="mx-auto">
            <b-button
              block
              @click="queryBankSn()"
              variant="danger"
              :disabled="disabled"
              >Query</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- loading toast -->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">Loading</p>
        </div>
      </div>
    </b-container>
    <hr />
    <div class="tipDiv">
      <p>
        If you have applied for a custom DIY card online, you can check the
        progress of the card application
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
import { mobile_pattern } from "@/js/verifyData";
export default {
  name: "QueryOrder_Dubai",
  data() {
    return {
      // name: "",
      mobile: "",
      disabled: true,
      loading: false,
      showToast: false,
      toastMsg: ""
    };
  },
  watch: {
    mobile: function(newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (this.mobile.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    }
  },
  methods: {
    // 测试接口
    getCallStatus() {
      axios
        .get(
          "https://ts.hengbao.net.cn/pos/device/callStatus" +
            "?" +
            "orderNo=" +
            "1767100635539816450" +
            "&" +
            "status=" +
            "1"
        )
        .then(res => {
          console.log(res);
        });
    },
    showToastMsg: function(msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function() {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function() {
      this.loading = true;
    },
    hideLoading: function() {
      this.loading = false;
    },
    queryBankSn: function() {
      const pattMobile = mobile_pattern;
      if (!pattMobile.test(this.mobile)) {
        this.showToastMsg("请输入正确的手机号");
        return;
      }
      var that = this;
      let param = this.mobile;
      console.log("param--->", param);
      that.showLoading();
      axios
        .get(
          config.config_DubaiCard.queryOrdersByPhone +
            "?" +
            "customPhone=" +
            param
        )
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            that.hideLoading();
            let orderObj = res.data.data[0];
            this.toOrderList(orderObj);
          } else {
          }
        })
        .catch(function(error) {
          that.hideLoading();
          console.log(error);
        });
    },
    toOrderList: function(bankSerialObj) {
      var queryResult = JSON.stringify(bankSerialObj);
      this.$router.push({
        name: "OrderList_Dubai",
        params: {
          bankSerialObj: queryResult
        }
      });
    }
  }
};
</script>

<style scoped>
.page {
  margin-top: 4vh;
}

.rowBtn {
  margin-top: 3rem;
}

.tipDiv {
  padding-left: 16px;
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/DubaiCard/QueryOrder_Dubai.vue